import React, { useEffect, useState } from 'react';
import { TbMapPinFilled, TbStarFilled, TbChevronLeft, TbChevronRight } from 'react-icons/tb';
import classNames from 'classnames';

export type Review = {
  rating: number;
  content: string;
  author: string;
  city: string;
  // avatarSrc: string;
};

export interface ReviewClientRestoProps {
  reviews: Review[];
}

export const ReviewClientResto: React.FC<ReviewClientRestoProps> = ({ reviews }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [reviewsPerPage, setReviewsPerPage] = useState(3);

  useEffect(() => {
    const updateReviewsPerPage = () => {
      if (window.innerWidth < 640) {
        setReviewsPerPage(1); // mobile
      } else if (window.innerWidth < 1024) {
        setReviewsPerPage(2); // tablette
      } else {
        setReviewsPerPage(3); // desktop
      }
    };

    updateReviewsPerPage();
    window.addEventListener('resize', updateReviewsPerPage);
    return () => window.removeEventListener('resize', updateReviewsPerPage);
  }, []);

  const handlePrev = () => {
    setCurrentIndex((prev) => Math.max(prev - reviewsPerPage, 0));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => Math.min(prev + reviewsPerPage, reviews.length - reviewsPerPage));
  };

  const visibleReviews = reviews.slice(currentIndex, currentIndex + reviewsPerPage);

  return (
    <div className="relative">
      <button
        onClick={handlePrev}
        className="absolute left-2 top-1/2 -translate-y-1/2 z-10 bg-white border p-2 rounded-full hover:bg-gray-100 disabled:opacity-30"
        disabled={currentIndex === 0}
      >
        <TbChevronLeft size={20} />
      </button>
      <button
        onClick={handleNext}
        className="absolute right-2 top-1/2 -translate-y-1/2 z-10 bg-white border p-2 rounded-full hover:bg-gray-100 disabled:opacity-30"
        disabled={currentIndex + reviewsPerPage >= reviews.length}
      >
        <TbChevronRight size={20} />
      </button>

      <div
        className={classNames(
          'grid gap-5 border rounded-xl px-6 py-5',
          reviewsPerPage === 1 ? 'grid-cols-1' : reviewsPerPage === 2 ? 'grid-cols-2' : 'grid-cols-3'
        )}
      >
        {visibleReviews.map((review, index) => (
          <div key={index} className="flex space-x-4 bg-gray-400/5 p-5 rounded-xl text-sm text-gray-500">
            {/* <img draggable={false} alt="restaurant review" src={review.avatarSrc} className="size-10 rounded-xl bg-gray-100" /> */}
            <div className="flex-1">
              {/* <h3 className="font-semibold text-gray-900">{review.author}</h3> */}
              <span className="flex items-center mt-0.5 gap-1 text-gray-700">
                <TbMapPinFilled size={15} />
                <h4 className="font-medium italic">{review.city}</h4>
              </span>
              <div className="mt-2 flex items-center">
                {[0, 1, 2, 3, 4].map((rating) => (
                  <TbStarFilled
                    key={rating}
                    aria-hidden="true"
                    className={classNames(review.rating > rating ? 'text-yellow-400' : 'text-gray-300', 'size-5 shrink-0')}
                  />
                ))}
              </div>
              <p className="mt-3 text-sm/6 text-gray-500">{review.content}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
